"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchAllProducts = exports.fetchMachineDetail = void 0;
const ApiMachineRepo_1 = require("../../../modules/machine/infra/ApiMachineRepo");
const getProductsByMachine_1 = require("../../../modules/machine/app/getProductsByMachine");
const ApiProductRepo_1 = require("../../../modules/product/infra/ApiProductRepo");
const Machine_1 = require("../../../modules/machine/domain/Machine");
const fetchMachineDetail = async (id) => {
    if (!id) {
        return {
            machine: (0, Machine_1.emptyMachine)(),
            aisles: [],
        };
    }
    const machineRepo = (0, ApiMachineRepo_1.createApiMachineRepo)();
    const machineData = await (0, getProductsByMachine_1.getProductsByMachine)(machineRepo, id);
    return machineData;
};
exports.fetchMachineDetail = fetchMachineDetail;
const fetchAllProducts = async (page, pageSize) => {
    const productRepo = (0, ApiProductRepo_1.createApiProductRepo)();
    return await productRepo.getAll(page, pageSize);
};
exports.fetchAllProducts = fetchAllProducts;
